import { NgModule } from '@angular/core';
import { DetectVisibilityDirective } from '../detect-visibility.directive';

/**
 * Shared custom directives that are needed by lazy-loaded feature modules (which
 * cannot see AppModule's declarations). AppModule imports this so the existing
 * app-wide users keep working unchanged. Grow this as future lazy modules need
 * more shared directives.
 */
@NgModule({
  declarations: [DetectVisibilityDirective],
  exports: [DetectVisibilityDirective],
})
export class SharedDirectivesModule {}
